import { IApplicationContext } from 'shared/types/applicationContext';
import { IOffersHistoryListingData } from 'shared/types/offersHistory';
import { prepareOffersHistory } from 'shared/mappers/offersHistory';
import {
  IGetHouseOfferHistoryDesktopOptions,
  TGetHouseOfferHistoryDesktopResponse_1,
  IGetHouseOfferHistoryDesktopResponse200,
  IGetHouseOfferHistoryDesktopResponse400,
  TGetHouseOfferHistoryDesktopResponseError,
  fetchGetHouseOfferHistoryDesktop,
} from 'shared/repositories/valuation-offer-history/v4/get-house-offer-history-desktop';
import { request } from 'shared/utils/request';
import { assertResponseError } from 'shared/utils/errors';
import { TRequestParamsWithoutHttpApi } from 'shared/types/request';

type TParameters = TRequestParamsWithoutHttpApi<
  IGetHouseOfferHistoryDesktopOptions<IGetHouseOfferHistoryDesktopResponse200, IGetHouseOfferHistoryDesktopResponse400>
>;

export const fetchHouseOfferHistory = async (
  context: IApplicationContext,
  parameters: TParameters,
): Promise<IOffersHistoryListingData | null> =>
  request<
    IOffersHistoryListingData | null,
    TParameters,
    TGetHouseOfferHistoryDesktopResponse_1,
    TGetHouseOfferHistoryDesktopResponseError
  >(context, {
    parameters,
    domain: 'fetchHouseOfferHistory',
    defaultValue: null,
    fetchFunction: fetchGetHouseOfferHistoryDesktop,
    errorHandler: assertResponseError,
    prepareFunction: prepareOffersHistory,
  });
